import type { StateId } from './types';
import type { TKey } from '../i18n/dictionary';

/** Prototyp, pole REASONS. Používá dialog Nahlásit dispečerům (F3.3). */
export interface ReasonDef {
  /** Hodnota posílaná na backend – payload B.1. */
  id: 'ALREADY_CANCELLED' | 'ALREADY_DELIVERED' | 'ALREADY_RETURNED' | 'OTHER';
  key: TKey;
  /** U kterého stavu se předvolí (odznak PODLE STAVU). */
  forState: StateId | null;
}

export const REASONS: ReasonDef[] = [
  { id: 'ALREADY_CANCELLED', key: 'r_zrusena', forState: 'zrusena' },
  { id: 'ALREADY_DELIVERED', key: 'r_dorucena', forState: 'dokoncena' },
  { id: 'ALREADY_RETURNED', key: 'r_vracena', forState: 'vraceno' },
  { id: 'OTHER', key: 'r_jiny', forState: null },
];

export function defaultReasonFor(state: StateId): ReasonDef | null {
  return REASONS.find((r) => r.forState === state) ?? null;
}
